import { render, staticRenderFns } from "./SubCategory.vue?vue&type=template&id=94c240da&scoped=true&"
import script from "./SubCategory.vue?vue&type=script&lang=js&"
export * from "./SubCategory.vue?vue&type=script&lang=js&"
import style0 from "./SubCategory.vue?vue&type=style&index=0&id=94c240da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c240da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94c240da')) {
      api.createRecord('94c240da', component.options)
    } else {
      api.reload('94c240da', component.options)
    }
    module.hot.accept("./SubCategory.vue?vue&type=template&id=94c240da&scoped=true&", function () {
      api.rerender('94c240da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform/components/SubCategory.vue"
export default component.exports